






























































































import {Component, Mixins, Prop} from 'vue-property-decorator';
import MenuComponent from "@/components/layouts/base/MenuComponent.vue";
import UserComponent from "@/components/layouts/base/UserComponent.vue";
import AffairComponent from "@/components/layouts/base/AffairComponent.vue";
import LogoComponent from "@/components/layouts/base/LogoComponent.vue";
import MobileMenuComponent from "@/components/responsive/menu/MobileMenuComponent.vue";
import {ResponsiveMixin} from "@/mixins/ResponsiveMixin";
import Overlay from "@/models/Overlay";
import Breadcrumb from "@/models/Breadcrumb";
import Alert from '@/models/Alert';
import Action from '@/models/Action';

@Component({
    components: {
        MobileMenuComponent, LogoComponent, AffairComponent, UserComponent, MenuComponent}
})
export default class BaseLayout extends Mixins(ResponsiveMixin) {
    drawer = null;

    //@ts-ignore
    @Prop(Overlay) overlay: Overlay;
  //@ts-ignore
    @Prop(Alert) alert;
  //@ts-ignore
    @Prop(Array) breadcrumbs: Breadcrumb[];
  //@ts-ignore
    @Prop(Array) actions: Action[];
}
